$(document).on 'turbo:load', ->
  new App.Pages.Series() if $('.seriesIndexView').length

class @App.Pages.Series
  constructor: ->
    self = this
    self.wrapper = $('#gridWrapper')
    self.container = $('#gridContainer')
    @setupGrid()
    @bindElements()
    @_gridBorderCheck()
    @_checkColSize()
    @_checkSeriesWindow()
    if window.location.hash
      $('[data-hash="' + window.location.hash.replace('#/', '') + '"] .gridMask').click()

  setupGrid: ->
    @container.isotope
      transformsEnabled: false
      animationEngine: 'jquery'
      animationOptions: duration: 750
      itemSelector: '.gridCell'
      masonry: columnWidth: 299
      resizable: false

  bindElements: ->
    $('.gridCell', self.wrapper).not('.sponsored').on 'mouseenter mouseleave', @_gridCellHover
    $('.gridCell').find('.gridCellWrapper').on 'click', _.bind(@_gridCellExpand, this)

  _checkSeriesWindow: ->
    windowX = $(window).width()
    gridContainerX = $('#gridContainer').width()
    gridContainerOrigX = $('#gridContainer').width()
    $(window).on 'resize', =>
      windowX = $(window).width()
      gridContainerX = $('#gridContainer').width()
      if gridContainerX <= 768 and gridContainerX != gridContainerOrigX
        @_sizeToCol1()
        gridContainerOrigX = $('#gridContainer').width()
        @_resetLayout()
      else if gridContainerX <= 897 and gridContainerX != gridContainerOrigX
        @_sizeToCol2()
        gridContainerOrigX = $('#gridContainer').width()
        @_resetLayout()
      else
        if gridContainerX != gridContainerOrigX
          @_sizeToCol2()
          gridContainerOrigX = $('#gridContainer').width()
          @_resetLayout()

  _checkColSize: ->
    if $('#gridContainer').width() <= 768
      @_sizeToCol1()
    else
      @_sizeToCol2()

  _sizeToCol1: ->
    $('.col2').find('.gridBgInner').each ->
      $(this).find('img.col1').css display: 'block'
      $(this).find('img.col2').css display: 'none'

    $('.col1').find('.gridBgInner').each ->
      $(this).find('img.col1').css display: 'block'
      $(this).find('img.col2').css display: 'none'

  _sizeToCol2: ->
    $('.col2').find('.gridBgInner').each ->
      $(this).find('img.col2').css display: 'block'
      $(this).find('img.col1').css display: 'none'

    $('.col1').find('.gridBgInner').each ->
      $(this).find('img.col1').css display: 'block'
      $(this).find('img.col2').css display: 'none'
      return

  # Hover Animation effects - can we replace with CSS transitions?
  _gridCellHover: (e) ->
    $t = $(this)
    switch e.type
      when 'mouseenter'
        if $t.is('.expanded, .expand') or $('#gridWrapper').hasClass('pageLoading')
          break
        if $t.hasClass('col1')
          $t.find('.gridBgInner img.col2').hide()
          $t.find('.gridBgInner').css(opacity: 0).animate { opacity: 1 }, 250, 'easeOutQuart'
          $t.find('.gridBgInner img.col1').css(
            width: '75%'
            marginTop: '10%').animate {
            width: '99%'
            marginTop: '0%'
          }, 150, 'easeOutQuart'
        if $t.hasClass('col2') and $('#gridContainer').width() > 768
          $t.find('.gridBgInner img.col1').css display: 'none'
          $t.find('.gridBgInner img.col2').css display: 'block'
          $t.find('.gridBgInner').css(opacity: 0).animate { opacity: 1 }, 250, 'easeOutQuart'
          $t.find('.gridBgInner img.col2').css(
            width: '80%'
            marginTop: '3%').animate {
            width: '99%'
            marginTop: '0%'
          }, 150, 'easeOutQuart'
        if $t.hasClass('col2') and $('#gridContainer').width() < 768
          $t.find('.gridBgInner img.col2').css display: 'none'
          $t.find('.gridBgInner img.col1').css display: 'block'
          $t.find('.gridBgInner').css(opacity: 0).animate { opacity: 1 }, 250, 'easeOutQuart'
          $t.find('.gridBgInner img.col1').css(
            width: '75%'
            marginTop: '10%').animate {
            width: '99%'
            marginTop: '0%'
          }, 150, 'easeOutQuart'
      when 'mouseleave'
        if $t.hasClass('col1')
          $t.find('.gridBgInner').animate { opacity: 0 }, 250, 'easeInOutQuart'
        if $t.hasClass('col2') and $('#gridContainer').width() > 768
          $t.find('.gridBgInner').animate { opacity: 0 }, 250, 'easeInOutQuart'
        if $t.hasClass('col2') and $('#gridContainer').width() < 768
          $t.find('.gridBgInner').animate { opacity: 0 }, 250, 'easeInOutQuart'

  _gridCellExpand: (e) ->
    self = this
    $cell = $(e.target).parents('.gridCell')
    if $cell.hasClass('sponsored')
      window.location.href = $cell.data('url')

    if !$cell.hasClass('expanded')
      pageTitle = $cell.data('title') + ' Series | TED-Ed'
      history.pushState { module: 'series' }, pageTitle, '/series/?series=' + $cell.data('hash')
      $.getScript $cell.data('url') # load content
      @_gridBorderFade()
      $cell.addClass('expand focused').find('.gridTitle, .gridVideoCount, .gridBackground').animate { opacity: 0 }, 200
      $('meta[property="og:title"]').attr 'content', pageTitle
      $('meta[property="og:url"]').attr 'content', window.location.protocol + '//' + window.location.hostname + '/series/?series=' + $cell.data('hash')
      document.title = pageTitle
      setTimeout (->
        self._gridColExpandTransition()
      ), 300

  _gridColExpandTransition: ->
    $('.gridCell', @wrapper).removeClass 'expanded'
    $('.expand', @wrapper).addClass 'expanded'
    $('.expanded', @wrapper).removeClass('expand').find('.expandedContent, .expandedFooterBackground').animate { opacity: 1 }, 600, 'easeOutQuart'
    @wrapper.addClass('pageLoading').removeClass 'pageLoaded'
    @_resetLayout()

  _gridColCollapseTransition: ($cell) ->
    $cell.removeClass 'expanded'
    @_resetLayout()

  _resetLayout: ->
    @container.addClass('pageLoaded').isotope 'reLayout', _.bind(@_gridBorderCheck, this)

  # This function will remove all borders & expanded content prior to reorganizing the layout
  _gridBorderFade: ->
    $('.expanded', self.wrapper).find('.expandedContent, .expandedFooterBackground, .expandedBackground').animate { opacity: 0 }, 500
    $('.gridCellBorderHorizontal, .gridCellBorderVertical', self.wrapper).animate { opacity: 0 }, 500, 'easeInOutQuart'

  # Check borders
  _gridBorderCheck: ->
    $('.focused', @wrapper).removeClass('focused').find('.gridTitle, .gridVideoCount, .gridBackground, .expandedBackground').animate { opacity: 1 }, 500, 'easeOutQuart'
    @wrapper.removeClass 'pageLoading'
    @wrapper.addClass 'pageLoaded'
    @_gridBorderCheckVertical()
    @_gridBorderCheckHorizontal()
    if $('.expanded').length > 0
      $currentExpandedPosition = $('.expanded').offset()
      $('html, body').delay(100).animate { scrollTop: $currentExpandedPosition.top - 75 }, 500

  # This function will detect and fade out vertical boarders depending on X position of grid cell
  _gridBorderCheckVertical: ->
    $('.gridCell', @wrapper).each ->
      $currentCell = $(this)
      $currentCellPosition = $currentCell.position()
      $gridContainerWidth = $('#gridContainer').width()
      # note: define var for x offset to support dynamic layout
      if $currentCellPosition.left >= $('#gridContainer').width() - $currentCell.width() - 5 and $(this).hasClass('col1')
        $(this).find('.gridCellBorderVertical').animate { opacity: 0 }, 500
      else if $currentCellPosition.left >= $('#gridContainer').width() - $currentCell.width() - 5 and $(this).hasClass('col2')
        $(this).find('.gridCellBorderVertical').animate { opacity: 0 }, 500
      else if $currentCellPosition.left >= $('#gridContainer').width() - $currentCell.width() - 20 and $(this).hasClass('expanded')
        $(this).find('.gridCellBorderVertical').animate { opacity: 0 }, 500
      else
        $(this).find('.gridCellBorderVertical').animate { opacity: 1 }, 750

  # This function will detect and fade out vertical borders depending on Y position of grid cell
  _gridBorderCheckHorizontal: ->
    $('.gridCell', @wrapper).each ->
      $currentCell = $(this)
      $currentCellPosition = $currentCell.position()
      $currentGridContainer = $('#gridContainer').height()
      $currentOffset = $currentGridContainer - ($currentCellPosition.top)
      if $currentOffset < 250
        $(this).find('.gridCellBorderHorizontal').animate { opacity: 0 }, 750
      else
        $(this).find('.gridCellBorderHorizontal').animate { opacity: 1 }, 750
